<template>
    <div class="studio_reports">
        <div class="banner-title">
            <div>
                <div>
                    <label for="">Plataformas</label>
                    <span>{{platformsCant}}</span>
                </div>
            </div>
            <div><h3>Studio Plataformas</h3></div>
            <div>
                <div>
                    <button @click="estadisticas()" class="">Descargar estadisticas</button>
                </div>
            </div>
        </div>
        <div class="platforms-list">
            <div class="platforms">
                <div v-for="(platform, index) in platforms" :key="index">
                    <div>
                        <div>
                            <img src="@/assets/plataformas/BongaCams.png" alt="" v-if="platform.type === 'Bongacams'"/>
                            <img src="@/assets/plataformas/CAM4.png" alt="" v-if="platform.type === 'Cam4'"/>
                            <img src="@/assets/plataformas/camsoda.png" alt="" v-if="platform.type === 'Camsoda'"/>
                            <img src="@/assets/plataformas/chaturbate.svg" alt="" v-if="platform.type === 'Chaturbate'"/>
                            <img src="@/assets/plataformas/skyprivate.webp" alt="" v-if="platform.type === 'Skyprivate'"/>
                            <img src="@/assets/plataformas/Stripchat.png" alt="" v-if="platform.type === 'Stripchat'"/>
                            <img src="@/assets/plataformas/Myfreecams.png" alt="" v-if="platform.type === 'Myfreecams'"/>
                        </div>
                        <div class="balance">
                            <label for="">{{priceFormat(platform.dolar_value)}}</label>
                        </div>
                        <div>
                            <button @click="$router.push({name: lowCase(platform.type)})">Ver ingresos modelos</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import API from '@/api'
import Price from '@/utils/ConvertPriceNumber'

export default {
    name: 'studio_reports',
    data() {
        return {
            platforms: []
        }
    },
    computed: {
        platformsCant: {
            get() {
                console.log(this.platforms)
                var total = this.platforms.reduce((n, b) => n + 1, 0)
                return total
            }
        },
        platformsTotals: {
            get() {
                var total = this.platforms.reduce((n, b) => n + b.dolar_value, 0)
                return total
            }
        }
    },
    methods: {
        estadisticas() {
            API.getEstadisticas()
                .then((res) => {
                    setTimeout(() => {
                        window.open(res.link)
                    }, 2000)
                })
        },
        priceFormat: function(item) {
            return Price(item)
        },
        lowCase(platform) {
            return platform.toLowerCase()
        },
        getPlatformsCant() {
            API.getPlatformsStudioCant()
                .then((res) => {
                    this.platforms = res
                })
        }
    },
    mounted() {
        this.getPlatformsCant()
    },
    beforeMount() {
        this.$root.$emit('changePlatform', this.$route.name)
    }
}
</script>

<style scoped>
    .studio_reports {
        width: 100%;
        height: 78vh;
        padding: 20px;
        background-color: #cdcdcd;
    }
    .studio_reports > .banner-title {
        height: 15%;
        display: flex;
        background-color: #e0b059;
        border-radius: 20px;
        border-style: outset;
    }
    .studio_reports > .banner-title > div {
        width: 100%;
        position: relative;
        text-align: center;
    }
    .studio_reports > .banner-title > div > div, .studio_reports > .banner-title > div > h3{
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
    .studio_reports > .banner-title > div > div {
        display: grid;
    }
    .studio_reports > .banner-title > div > div > label {
        font-weight: bold;
        font-size: 25px;
        color: #fff;
    }
    .studio_reports > .banner-title > div > div > span {
        font-weight: bold;
        font-size: 25px;
        color: #000;
    }
    .studio_reports > .platforms-list {
        width: 100%;
    }
    .studio_reports > .platforms-list > .platforms{
        padding: 20px;
        width: 100%;
    }
    .studio_reports > .platforms-list > .platforms > div{
        background-color: aqua;
        border-radius: 20px;
        border-style: outset;
        padding: 20px;
        margin: 5px;
        width: 100%;
        height: 75px;
    }
    .studio_reports > .platforms-list > .platforms > div > div {
        width: 100%;
        display: flex;
    }
    .studio_reports > .platforms-list > .platforms > div > div > div{
        position: relative;
        height: 100%;
        width: 33%;
        text-align: center;
    }
    .studio_reports > .platforms-list > .platforms > div > div > div > img{
        height: 25px;
    }
    .studio_reports > .platforms-list > .platforms > div > div > div.balance > label{
        font-weight: bold;
        font-size: 22px;
    }
    .studio_reports > .platforms-list > .platforms > div > div > div > button, button{
        background-color: #e0b059;
        color: #fff;
        width: 200px;
        border-radius: 30px;
    }
</style>



// WEBPACK FOOTER //
// src/components/Reportes/StudioPlatforms.vue